import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=337b463f&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('337b463f')) {
      api.createRecord('337b463f', component.options)
    } else {
      api.reload('337b463f', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=337b463f&", function () {
      api.rerender('337b463f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fPX6oW4tXsFX/JS/comp/ImgFallback.vue"
export default component.exports